export default [{
  version: '1.1.1',
  features: [],
  bugs: [{
    title: 'Performance',
    body: 'De app blijft snel reageren wanneer er veel items op de kalender staan'
  }]
}, {
  version: '1.1.0',
  features: [{
    title: 'Plan gewas in het verleden en in de toekomst',
    body: 'Bij het plannen van een gewas wordt er niet meer naar het jaartal gekeken'
  }, {
    title: 'Zie wat je gedaan hebt',
    body: 'In kalender acties uit het verleden zien'
  }, {
    title: 'Zie wat je te doen hebt op een bepaalde dag',
    body: 'Klik op een dag en zie wat je dan te doen hebt'
  }],
  bugs: [{
    title: 'Memory issues',
    body: 'Geheugen gebruik zo veel mogelijk beperkt houden'
  }]
}, {
  version: '1.0.1',
  features: [],
  bugs: [{
    title: 'Verlanglijst leren tellen',
    body: 'De verlanglijst-counter telt nu juist'
  }]
}, {
  version: '1.0.0',
  features: [{
    title: 'Wizard aangemakt',
    body: 'Hulp nodig met planning? De wizard is er voor u'
  }],
  bugs: [{
    title: 'UI/UX verbeterd',
    body: 'De Kalender en andere elementen zijn aangepast om het u makkelijker en mooier te maken'
  }]
}, {
  version: '0.11.0',
  features: [{
    title: 'Zet voornaam en naam bij het aanmaken van user',
    body: 'Tijdens het registeren kan je je naam meegeven'
  }],
  bugs: [{
    title: 'Email validatie tijdens registreren',
    body: 'Check om te zien als ingegeven emailadress correct is'
  }]
}, {
  version: '0.10.0',
  features: [{
    title: 'Maak user aan',
    body: 'Login functionaliteit uitgebreid met regisreer mogelijkheid'
  }],
  bugs: []
}, {
  version: '0.9.0',
  features: [{
    title: 'Producten toevoegen aan verlanglijst vanuit planning',
    body: 'Als je een planning-item opent, kan je de nodige producten zien en toevoegen aan je verlanglijst'
  }],
  bugs: [{
    title: 'Planning restyle',
    body: 'Actie-icon wordt nu buiten de afbeelding getoond ipv er in'
  }]
}, {
  version: '0.8.0',
  features: [{
    title: 'Kies je variatie',
    body: 'Als variabel product, kies variatie alvorens het toevoegen aan verlanglijst'
  }],
  bugs: [{
    title: 'Mooiere uitlijning in verlanglijst',
    body: 'Breedte van velden aangepast zodat het mooi uitgelijnd uitkomt'
  }, {
    title: 'Dialog tonen wanneer verlanglijst leeg is',
    body: 'Niet meer automatisch redirecten naar winkelmand (dit wordt gezien als pop-up en wordt vaak geblokkeerd door browsers)'
  }]
}, {
  version: '0.7.1',
  features: [],
  bugs: [{
    titel: 'Toevoegen aan winkelcar werkt weer',
    body: 'Issue opgelost waardoor je geen producten aan je winkelmand kon toevoegen'
  }]
}, {
  version: '0.7.0',
  features: [{
    title: 'Kies je variatie',
    body: 'Als variabel product, kies variatie alvorens het toevoegen aan winkelmand'
  }],
  bugs: []
}, {
  version: '0.6.1',
  features: [],
  bugs: [{
    title: 'Terugdraaaien Authorisatie & Facebook login gebruiken',
    body: 'Auth0 wordt niet meer gebruikt voor authorisatie'
  }, {
    title: 'Kleuren aanpassen',
    body: 'Contrasterende kleuren gebruiken in kalender en notificatie bar'
  }, {
    title: 'Gewas afbeelding weergeven in planning',
    body: 'Gewas afbeelding en actie icon worden getoond in planning'
  }, {
    title: 'Titel van dialog altijd zichtbaar',
    body: 'Bij het scrollen blijft de titel van de dialogbox zichtbaar'
  }, {
    title: 'Weergave planning item dialog verbeterd [WIP]',
    body: 'Titeljes aangepast, inhoud mooier weergeven...'
  }, {
    title: 'Zaaitabel neemt nu de volledige breedte',
    body: '100% van de beschikbare ruimte wordt nu gebruikt door zaaitabel'
  }]
}, {
  version: '0.6.0',
  features: [{
    title: 'Product info weergeven',
    body: 'Vanuit de gewassen pagina kan je info opvragen van producten [WIP]'
  }, {
    title: 'Bestelling plaatsen vanuit verlanglijst',
    body: 'Geef je volledige verlanglijst door als bestelling naar webshop'
  }, {
    title: 'Prijzen van artikelen bekijken',
    body: 'In verlanglijst zie je nu hoveel een artikel kost'
  }],
  bugs: [{
    title: 'Winkelmand is nu verlanglijst',
    body: 'De app houdt nu een verlanglijstje ipv winkelmand'
  }, {
    title: 'Containers verwijderd',
    body: 'Containers zullen in de tekst beschreven worden'
  }, {
    title: 'Offline data access verbeterd',
    body: 'Kleine defects ivm offline data access aangepast'
  }, {
    title: 'Badge met aantal producten in verlanglijst tonen',
    body: 'In de bottomnavbar is er een badge met de counter van het aantal artikelen in je verlanglijst'
  }]
}, {
  version: '0.5.0',
  features: [{
    title: 'Product toevoegen aan winkelmand',
    body: 'Vanuit de gewassen pagina kan je nu producten toevoegen aan je winkelmand'
  }, {
    title: 'Winkelmand bekijken',
    body: 'Eerste stappen ivm bekijken van winkelcar (bestelling plaatsen komt nog)'
  }, {
    title: 'Service worker registreren voor offline gebruik',
    body: 'Testen offline data access'
  }],
  bugs: [{
    title: 'Markeer als gedaan werkt weer',
    body: 'Klein probleempje gehad hiermee'
  }]
}, {
  version: '0.4.1',
  features: [],
  bugs: [{
    title: 'Login issue fixed',
    body: 'Redirect url was niet ingesteld voor productie'
  }]
}, {
  version: '0.4.0',
  features: [{
    title: 'Authenticatie verhuisd naar Auth0',
    body: 'Auth0 is een bekende authorisatie party, hierdoor kunnen we meerdere login functionaliteiten voorzien.'
  }],
  bugs: [{
    title: 'Verbetering in UI/UX',
    body: 'Snackbar is bovenaan en verwijder actie/teelt is altijd zichtbaar'
  }]
}, {
  version: '0.3.2',
  features: [],
  bugs: [{
    title: 'Meerdere teelten toevoegen in 1 sessie',
    body: 'Het is nu terug mogelijk om meerdere teelten toe te voegen aan je planning'
  }]
}, {
  version: '0.3.1',
  features: [],
  bugs: [{
    title: '"X" knop sluit dialogvenster',
    body: 'Sluiten van dialogvenster door op "x" te drukken (planning overzicht)'
  }]
}, {
  version: '0.3.0',
  features: [{
    title: 'Bevestig legen van planning',
    body: 'Bevestiging vragen voor acties verwijderd worden via settings'
  }, {
    title: 'Feedback op acties',
    body: 'Feedback weergeven wanneer actie gebeurt'
  }, {
    title: 'Teelt verwijdere',
    body: 'Het is nu mogelijk om een volledige teelt uit je planning te verwijderen'
  }, {
    title: 'Actie verwijderen',
    body: 'Verwijder één enkele actie uit je planning'
  }],
  bugs: []
}, {
  version: '0.2.0',
  features: [{
    title: 'Changelog toegevoegd',
    body: 'Zie wat er nieuw is versie na versie'
  }],
  bugs: []
}, {
  version: '0.1.0',
  features: [{
    title: 'Gewassen bekijken',
    body: 'Zie lijst van gewas met of zonder filter'
  }, {
    title: 'Enkel gewas bekijken',
    body: 'Zie teelten (met zaaikalender en acties) + algemene info'
  }, {
    title: 'Teelt toevoegen aan planning',
    body: 'Alle acties voor die teelt toevoegen aan kalender'
  }, {
    title: 'Planning bekijken',
    body: 'Zie planning met info over deze actie'
  }, {
    title: 'Notities bij actie',
    body: 'Schrijf iets voorjezelf bij een actie'
  }, {
    title: 'Markeer actie als gedaan',
    body: 'Als je een actie hebt gedaan, markeer deze als gedaan'
  }],
  bugs: []
}]
